import styled from 'styled-components';
import { CFBaseFieldStyles, CFBaseSelectFieldStyles, CFBaseTextFieldStyles, } from '@connectrn/ds-ui-base';
export const CFFieldElements = {
    FieldControlInput: styled.input `
    ${CFBaseFieldStyles.FieldControlFullType}
    ${CFBaseFieldStyles.FieldControl}
    ${CFBaseTextFieldStyles.TextFieldWeb}
  `,
    FieldControlSelect: styled.select `
    ${CFBaseFieldStyles.FieldControlFullType}
    ${CFBaseFieldStyles.FieldControl}
    ${CFBaseSelectFieldStyles.SelectFieldControlWeb}
  `,
    FieldControlTextarea: styled.textarea `
    ${CFBaseFieldStyles.FieldControlFullType}
    ${CFBaseFieldStyles.FieldControl}
    ${CFBaseTextFieldStyles.TextFieldWeb}
  `,
    FieldDecorator: styled.span `
    ${CFBaseFieldStyles.FieldDecorator}
  `,
    FieldRoot: styled.div `
    ${CFBaseFieldStyles.FieldRoot}
  `,
    FieldRootSelect: styled.button `
    ${CFBaseFieldStyles.FieldRoot}
    ${CFBaseSelectFieldStyles.SelectFieldControlWeb}
  `,
    FieldToggleOptionContainer: styled.label `
    ${CFBaseFieldStyles.FieldToggleOptionContainer}
  `,
    FieldToggleOptionLabel: styled.span `
    ${CFBaseFieldStyles.FieldToggleOptionLabel}
  `,
    FieldValue: styled.span `
    ${CFBaseFieldStyles.FieldValue}
    ${CFBaseFieldStyles.FieldValueWeb}
  `,
    FieldWrapper: styled.div `
    ${CFBaseFieldStyles.FieldWrapper}
    ${CFBaseFieldStyles.FieldWrapperWeb}
  `,
};
